import React from 'react';
import { NavLink } from 'react-router-dom';
import york from './assets/york.png';
import './styles/footer.css';

const Footer = () => {
  const menuItems = {
    main: [
      { label: 'Home', path: '/' },
      { label: 'About Us', path: '/about' },
      { label: 'Products', path: '/products' },
      { label: 'Request a Qoute', path: '/ordernow' },
      { label: 'Contact Us', path: '/contact' },
    ],
    // secondary: [
    //   { label: 'Help', path: '/help' },
    //   { label: 'Customer Support', path: '/customer-support' },
    //   { label: 'Delivery Details', path: '/delivery-details' },
    //   { label: 'Terms & Conditions', path: '/terms' },
    //   { label: 'Privacy Policy', path: '/privacy' },
    // ],
    secondary: [
      { label: 'Help', path: '#' },
      { label: 'Customer Support', path: '#' },
      { label: 'Delivery Details', path: '#' },
      { label: 'Terms & Conditions', path: '#' },
      { label: 'Privacy Policy', path: '#' },
    ],
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <NavLink to="/">
              <img
                src={york}
                alt="YORK Engineering Logo"
                className="footer-logo"
              />
            </NavLink>
            <p className="footer-description">
              YORK Engineering is a dynamic company committed to harnessing the power of technology to improve lives and drive innovation.
            </p>
          </div>

          {/* Menus Section */}
          <div className="footer-menus">
            {/* Main Navigation Menu */}
            <nav className="footer-nav">
              <ul>
                {menuItems.main.map((item) => (
                  <li key={item.path}>
                    <NavLink to={item.path} className="footer-nav-link">
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Secondary Navigation Menu */}
            <nav className="footer-nav">
              <ul>
                {menuItems.secondary.map((item) => (
                  <li key={item.path}>
                    <NavLink to={item.path} className="footer-nav-link">
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © Copyright 2025, All Rights Reserved by Aquiden
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;